/* Sink sold-out product cards to the end of any product grid (search + collections).
   Runs on load and re-runs whenever the grid re-renders (filters, sort, infinite scroll). */
(function () {
	var GRID = ".js-grid-wrapper";
	var BADGE = ".product-card__label--sold-out";
	var reordering = false;

	function sink(grid) {
		if (reordering) return;
		var kids = Array.prototype.slice.call(grid.children);
		if (!kids.length) return;
		var sold = kids.filter(function (k) {
			return k.querySelector && k.querySelector(BADGE);
		});
		if (!sold.length || sold.length === kids.length) return;
		var firstSold = kids.indexOf(sold[0]);
		var lastAvail = -1;
		kids.forEach(function (k, i) {
			if (sold.indexOf(k) === -1) lastAvail = i;
		});
		if (firstSold > lastAvail) return; /* already grouped at the end */
		reordering = true;
		sold.forEach(function (k) { grid.appendChild(k); });
		reordering = false;
	}

	function init() {
		Array.prototype.forEach.call(document.querySelectorAll(GRID), function (grid) {
			sink(grid);
			new MutationObserver(function () { sink(grid); })
				.observe(grid, { childList: true });
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
